import { useEffect, useState } from "react";
import { ImageOff } from "lucide-react";
import { resolveImage } from "@/lib/api";

export const SafeImage = ({ src, alt, className = "", testid, onStatus }) => {
  const [failed, setFailed] = useState(false);

  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <div
        data-testid={testid ? `${testid}-fallback` : undefined}
        className={`${className} flex items-center justify-center bg-[var(--trio-surface)] text-[var(--trio-muted)]`}
      >
        <ImageOff className="w-6 h-6 opacity-60" />
      </div>
    );
  }

  return (
    <img
      src={resolveImage(src)}
      alt={alt}
      data-testid={testid}
      className={className}
      onLoad={() => onStatus && onStatus("ok")}
      onError={() => {
        setFailed(true);
        onStatus && onStatus("error");
      }}
    />
  );
};
